module.exports = __webpack_public_path__ + "static/media/front-sided.6647d3e9.png";